/** Structural subset of `ModalityRow` (LearningFormatParts.tsx) — enough to resolve a slug. */
type ModalitySlugRow = {
	modality: {_id: string; slug: {current: string}};
	isSelected: boolean;
};

/** True only on the transition into the Learn more panel, not while it stays open or closes. */
export function didOpenLearnMore(
	nextValue: string | null,
	previousValue: string | null,
	learnMoreValue: string
): boolean {
	return nextValue === learnMoreValue && previousValue !== learnMoreValue;
}

export function getSelectedModalitySlug(
	modalityRows: ModalitySlugRow[]
): string | null {
	return (
		modalityRows.find((row) => row.isSelected)?.modality.slug.current ?? null
	);
}
